import React, { createContext, useContext, useEffect, useState } from 'react';
import { AppMetadata, appMetaService } from '../services/appMetaService';

const DEFAULT_APP_METADATA: AppMetadata = {
  version: null,
  chatbotName: 'Sara',
};

const AppMetaContext = createContext<AppMetadata>(DEFAULT_APP_METADATA);

export const AppMetaProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [metadata, setMetadata] = useState<AppMetadata>(DEFAULT_APP_METADATA);

  useEffect(() => {
    let isMounted = true;

    const loadMetadata = async () => {
      try {
        const nextMetadata = await appMetaService.getMetadata();
        if (isMounted) {
          setMetadata(nextMetadata);
        }
      } catch (error) {
        if (isMounted) {
          setMetadata(DEFAULT_APP_METADATA);
        }
        console.warn('Failed to load app metadata', error);
      }
    };

    void loadMetadata();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    document.title = `${metadata.chatbotName} Admin Dashboard - Arquitectura y Concreto`;
  }, [metadata.chatbotName]);

  return (
    <AppMetaContext.Provider value={metadata}>
      {children}
    </AppMetaContext.Provider>
  );
};

export const useAppMeta = (): AppMetadata => useContext(AppMetaContext);
